import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MediaBtnContainer } from '../../../pre-meeting/components/Buttons'
import { Tip } from '../../../../components/Tip'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useZoomContext } from '../../../../context/ZoomContext'
import { useTranslation } from 'react-i18next'
import { useSessionParams } from '../../../../hooks/useSessionParams'
import QuitModal from '../../../../components/Modals/QuitModal'
import { useHRExpertMentors } from '../../../../hooks/useHRExpertMentors'
import { useHRLeaveRequest } from '../../../../hooks/useHRLeaveRequest'
import { useUI } from '../../../../context/UIContext'

export const LeaveButton = () => {
    const { showError } = useUI()
    const { t } = useTranslation('meeting')
    const {
        mediaStream,
        zoomClient,
        setConfirmationDialog,
        isAudioStarted,
        isVideoStarted,
        setIsVideoStarted,
        setIsAudioStarted,
        isStartedScreenShare,
    } = useZoomContext()
    const navigate = useNavigate()
    const { room } = useSessionParams()
    const { isAttendingHelpRequest } = useHRExpertMentors()
    const { leaveHR } = useHRLeaveRequest()

    const stopMediaStream: () => void = useCallback(async () => {
        try {
            if (isAudioStarted) setIsAudioStarted(false)
            if (isStartedScreenShare) await mediaStream?.stopShareScreen()
            if (isVideoStarted) {
                setIsVideoStarted(false)
                mediaStream
                    ?.stopVideo()
                    .then(() => {
                        console.log('Component unmounted, video stopped')
                    })
                    .catch(error => {
                        console.error('Error stopping video when unmounting', error)
                    })
            }
        } catch (error) {
            console.log(error)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAudioStarted, isStartedScreenShare, isVideoStarted, mediaStream])

    const finalizeHelpRequest = useCallback(async () => {
        try {
            leaveHR()
        } catch (error) {
            showError(t('Error finalizing help request'))
        }
    }, [leaveHR, showError, t])

    const onLeaveClick = useCallback(async () => {
        try {
            if (isAttendingHelpRequest) {
                finalizeHelpRequest()
                return
            }
            if (zoomClient.isHost() && room === 'general') {
                setConfirmationDialog(<QuitModal />)
                return
            }
            stopMediaStream()
            await zoomClient.leave(false).catch(() => {
                console.log('Handling normal leave error')
            })
            navigate('/post-meeting/ended')
        } catch (error) {
            console.log('Error leaving meeting', error)
        }
    }, [
        zoomClient,
        room,
        stopMediaStream,
        navigate,
        setConfirmationDialog,
        isAttendingHelpRequest,
        finalizeHelpRequest,
    ])

    return (
        <div>
            <MediaBtnContainer
                wide
                active
                accent={!isAttendingHelpRequest}
                onClick={onLeaveClick}
                data-tooltip-id="leave-pre-action"
            >
                <FontAwesomeIcon
                    className="icon"
                    icon={['fas', !isAttendingHelpRequest ? 'phone-hangup' : 'arrow-left-to-bracket']}
                />
            </MediaBtnContainer>

            <Tip
                id="leave-pre-action"
                content={
                    isAttendingHelpRequest
                        ? t('quitModal.finalizeHelpRequest', 'Finalize Help Request')
                        : t('quitModal.quitButton')
                }
            />
        </div>
    )
}
